import type { ReactElement } from "react";
import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { StyledWizardFocusCard, StyledWizardFocusCardIconWrapper, StyledWizardFocusCardTextWrapper } from "./styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { OnboardingFocusQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";

const iconsByType: Record<OnboardingFocusQuestionType, IconName> = {
    [OnboardingFocusQuestionType.BookMoreMeetings]: "calendar-full",
    [OnboardingFocusQuestionType.CloseMoreDeals]: "mountain-full",
    [OnboardingFocusQuestionType.RetainAndGrowAccounts]: "rocket-full",
    [OnboardingFocusQuestionType.IncreaseSalesEfficiency]: "team-full",
};

interface Props {
    type: OnboardingFocusQuestionType;
    isActive?: boolean;
    onClick?: () => void;
}

const WizardFocusCard = ({ type, isActive, onClick }: Props): ReactElement => {
    return (
        <StyledWizardFocusCard
            className={isActive ? "activeCard" : ""}
            onClick={onClick}
        >
            <StyledWizardFocusCardIconWrapper>
                <SWReactIcons iconName={iconsByType[type]} />
            </StyledWizardFocusCardIconWrapper>

            <I18n
                element={StyledWizardFocusCardTextWrapper}
                translatable={{ key: `si.onboarding.wizard.card-title.${type}` }}
            />
        </StyledWizardFocusCard>
    );
}

export default WizardFocusCard;
